import { whichAnimationEnd } from '@/modules/animation-helpers';

export default function animate(el, animation, duration, onComplete) {
  const animationEnd = whichAnimationEnd();
  const originalDuration = el.style.animationDuration;
  duration = duration || 1;

  el.classList.add('animated', animation);
  el.style.animationDuration = `${duration}s`;
  el.addEventListener(
    animationEnd,
    () => {
      el.classList.remove('animated', animation);
      el.style.animationDuration = originalDuration;

      if (typeof onComplete === 'function') {
        onComplete.call(el);
      }
    },
    { once: true }
  );
}
